import { Tabs } from "antd";
import React, { useCallback, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PAGES, PERMISSION_DATA } from "../../lib/const";
import { TouchPointProvider } from "../../lib/context/touchpointProvider";
import useCustomerTabs from "../../lib/hooks/useCustomerTabs";
import usePermission from "../../lib/hooks/usePermisson";
import WithSidebar from "../../templates/withSidebar";
import CurrentCustomer from "./current";
import SearchCustomerCurrentProvider from "./current/searchContext";
import FutureCustomer from "./future";
import SearchCustomerFutureProvider from "./future/searchContext";
import SearchCustomerCompetitorProvider from "./customercompetitor/searchContext";
import Stakeholder from "./stakeholder";
import SearchCustomerStakeholderProvider from "./stakeholder/searchContext";
import TouchPointCustomer from "./touchpoint";
import Competitor from "./competitor";
import CustomerCompetitor from "./customercompetitor";
import SearchCompetitorProvider from "./competitor/searchContext";
import SearchAreaUsageProvider from "./areaUsage/searchContext";
import AreaUsage from "./areaUsage";
import Visit from "./visit";
import SearchVisitProvider from "./visit/searchContext";

const Customer = () => {
  const navigate = useNavigate();
  const { tabs, setTabs } = useCustomerTabs();
  const [searchParams] = useSearchParams();
  const currentMenu = searchParams.get("menu");
  const currentTab = searchParams.get("tab");

  const [roleUser1, isAll1] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.CURRENT_CUSTOMER
  );
  const [roleUser2, isAll2] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.FUTURE_CUSTOMER
  );
  const [roleUser3, isAll3] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.STAKEHOLDER
  );
  const [roleUser4, isAll4] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.TOUCHPOINT
  );
  const [roleUser5, isAll5] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.COMPETITOR
  );

  const setChangeTabfromState = useCallback(
    (tab) => {
      setTabs(tab);
    },
    [setTabs]
  );

  useEffect(() => {
    setChangeTabfromState(currentTab);
  }, [currentMenu, currentTab]);

  const onChangeTab = (key) => {
    setTabs(key);
    navigate({
      pathname: "/customer",
      search: `?menu=customer&tab=${key}`,
    });
  };

  const items = [
    (roleUser1[0]?.isCreate ||
      roleUser1[0]?.isEdit ||
      roleUser1[0]?.isDelete ||
      roleUser1[0]?.isView ||
      roleUser1[0]?.isExport) && {
      key: "current",
      label: <b>ลูกค้าปัจจุบัน</b>,
      children: (
        <SearchCustomerCurrentProvider>
          <CurrentCustomer />
        </SearchCustomerCurrentProvider>
      ),
    },
    (roleUser2[0]?.isCreate ||
      roleUser2[0]?.isEdit ||
      roleUser2[0]?.isDelete ||
      roleUser2[0]?.isView ||
      roleUser2[0]?.isExport) && {
      key: "future",
      label: <b>ลูกค้าอนาคต</b>,
      children: (
        <SearchCustomerFutureProvider>
          <FutureCustomer />
        </SearchCustomerFutureProvider>
      ),
    },

/*
    {
      key: "customercompetitor_domestic",
      label: <b>ลูกค้าของคู่แข่งในประเทศ</b>,
      children: (
        <SearchCustomerCompetitorProvider region = {"domestic"}>
          <CustomerCompetitor 
          region = {"domestic"} 
          header = {"ลูกค้าของคู่แข่งในประเทศ"}/>
        </SearchCustomerCompetitorProvider>
      ),
    },
    {
      key: "customercompetitor_international",
      label: <b>ลูกค้าของคู่แข่งต่างประเทศ</b>,
      children: (
        <SearchCustomerCompetitorProvider region = {"international"}>
          <CustomerCompetitor 
          region = {"international"}
          header = {"ลูกค้าของคู่แข่งต่างประเทศ"}
          />
        </SearchCustomerCompetitorProvider>  
      ),
    },
*/
    (roleUser3[0]?.isCreate ||
      roleUser3[0]?.isEdit ||
      roleUser3[0]?.isDelete ||
      roleUser3[0]?.isView) && {
      key: "stakeholder",
      label: <b>ผู้มีส่วนได้ส่วนเสีย</b>,
      children: (
        <SearchCustomerStakeholderProvider>
          <Stakeholder />
        </SearchCustomerStakeholderProvider>
      ),
    },
    (roleUser4[0]?.isCreate ||
      roleUser4[0]?.isEdit ||
      roleUser4[0]?.isDelete ||
      roleUser4[0]?.isView) && {
      key: "touchpoint",
      label: <b>Touch point</b>,
      children: (
        <TouchPointProvider>
          <TouchPointCustomer />
        </TouchPointProvider>
      ),
    },
    {
      key: "competitor",
      label: <b>คู่แข่ง</b>,
      children: (
        <SearchCompetitorProvider>
          <Competitor />
        </SearchCompetitorProvider>
      ),
    },
    {
      key: "areaUsage",
      label: <b>การใช้พื้นที่</b>,
      children: (
        <SearchAreaUsageProvider>
          <AreaUsage />
        </SearchAreaUsageProvider>
      ),
    },
    {
      key: "visit",
      label: <b>การเยี่ยมชม</b>,
      children: (
        <SearchVisitProvider>
          <Visit />
        </SearchVisitProvider>
      ),
    },
  ];

  return (
    <WithSidebar>
      <Tabs
        className="customer_tabs"
        defaultActiveKey={tabs}
        activeKey={tabs}
        items={items}
        onChange={onChangeTab}
      />
    </WithSidebar>
  );
};

export default Customer;
